import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { updatePayment } from '../utils/backend-api/updatePayment';

const usePaymentUpdate = () => {
  const { mutate, isLoading, isError } = useMutation(updatePayment, {
    onSuccess: (data) => {
      window.location.href = data.redirect_to;
    },
    onError: (error: { message: string; redirect_to?: string }) => {
      toast.error(error.message);
      if (error.redirect_to) {
        window.location.href = error.redirect_to;
      }
    },
  });
  return { mutate, isLoading, isError };
};

export default usePaymentUpdate;
